// src/api/backupApi.js
import apiClient from "./axios"; // Your pre-configured Axios instance with token handling

const backupApi = {
  /**
   * Downloads the full database backup as a ZIP file.
   * Returns a Blob.
   */
  exportBackup() {
    return apiClient.get("/data-backup/export", {
      responseType: "blob", // Important for binary file download
    });
  },

  /**
   * Imports a database backup from a ZIP file.
   * @param {File} file - The backup ZIP file to import
   * @returns {Promise} - Resolves to backend response
   */
  importBackup(file) {
    const formData = new FormData();
    formData.append("file", file);

    return apiClient.post("/data-backup/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

export default backupApi;
